<template>
    <div>
        <div class="formPosition">
            <v-card>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                    <span class="text-h5">Editar Estudante</span>
                </v-card-title>

                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field :rules="ruleTextRequired" v-model="estudanteInfo.nome"
                                    label="Nome completo"></v-text-field>
                            </v-col>

                            <v-col cols="12" md="3">
                                <v-text-field v-if="editarDados" required :rules="ruleBI" v-model="estudanteInfo.bi"
                                    :label="descricao" v-mask="mascara"></v-text-field>
                                <v-text-field v-if="!editarDados" required :rules="ruleBI" v-model="estudanteInfo.bi"
                                    :label="descricao" v-mask="mascara"></v-text-field>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-switch @change="outroDoc()"></v-switch>
                            </v-col>

                            <v-col cols="12" md="3">
                                <template>
                                    <v-menu ref="menubi" :rules="ruleTextRequired" v-model="menubi"
                                        :close-on-content-click="false" transition="scale-transition" offset-y
                                        full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="estudanteInfo.dataemissaobi"
                                                :rules="[v => !!v || 'Campo obrigatorio!']"
                                                label="Data de emissâo do documento" prepend-icon="event" readonly
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker ref="picker" max="2027-12-31" min="1950-01-01"
                                            v-model="dataEmissaoDocumento"
                                            @change="salvarDataDocumento"></v-date-picker>
                                    </v-menu>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="estudanteInfo.pai" label="Filho de:"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="estudanteInfo.mae" label="e de:"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">

                                <template>
                                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="estudanteInfo.data_nascimento"
                                                :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de nascimento"
                                                prepend-icon="event" readonly v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker ref="picker" v-model="dataNascimento" max="2022-12-31"
                                            min="1950-01-01" @change="salvarDataNascimento"></v-date-picker>
                                    </v-menu>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-combobox :rules="ruleRequired" v-model="provinciaSelected" :items="provinciasAll"
                                    item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb"
                                    return-object label="Natural de:"></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-combobox :rules="ruleRequired" v-model="municipioSelected"
                                    :items="municipiosFiltered" item-value="idMunicipio" item-text="descricao"
                                    return-object label="Município"></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-combobox v-model="sexoSelected" :rules="ruleRequired" item-value="idSexo"
                                    item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-combobox v-model="periodoSelected" :rules="ruleRequired" item-value="id"
                                    item-text="descricao" :items="periodos" chips label="Período "></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="estudanteInfo.telefone" label="Telefone"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="estudanteInfo.email" label="Email"></v-text-field>
                            </v-col>
                        </v-row>

                        <small>*Preencha correctamente os campos</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="FecharCard()"> Fechar </v-btn>
                        <v-btn color="green darken-1" text :disabled="!valid" @click="Guardar()"> Guardar </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </div>
    </div>
</template>

<script>
// Importações de dependências e plugins utilizados
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
import Swal from 'sweetalert2';
export default {
    name: 'editarEstudante', // Nome do componente
    directives: { mask }, // Diretiva para aplicação de máscara em campos de texto
    props: ['estudante'], // Propriedade passada para o componente
    data: () => ({
        // Declaração de variáveis de estado do componente
        editarDados: false,
        descricao: 'Nº do BI',
        mascara: '#########-AA-###',
        showConfirmacao: false,
        estudanteInfo: null,
        dataEmissaoDocumento: null,
        menubi: false,
        dataNascimento: null,
        ruleTextRequired: [ /* Regras de validação para campos de texto */
            value => !!value || 'campo obrigatório.',
            value => (value || '').length <= 70 || 'O máximo número de carácters atigidos',
            value => (value || '').length > 3 || 'carácteres insuficientes',
            value => {
                const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
                return !pattern.test(value) || 'Invalido.'
            }
        ],
        ruleBI: [ /* Regras de validação para campo de BI */
            value => !!value || 'campo obrigatório.',
            value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
        ],
        provinciasAll: [],
        municipiosAll: [],
        provinciaSelected: null,
        municipioSelected: null,
        municipiosFiltered: [],
        sexoSelected: null,
        dropdowSexo: [
            { idSexo: 'M', descricao: 'Masculino' },
            { idSexo: 'F', descricao: 'Femenino' }
        ],
        valid: true,
        ruleRequired: [value => !!value || 'campo obrigatorio'],
        overlay: false,
        menu: false,
        periodos: [
            { id: 'M', descricao: 'Manhã' },
            { id: 'T', descricao: 'Tarde' },
            { id: 'N', descricao: 'Noite' }
        ],
        periodoSelected: null
    }),

    // Método de ciclo de vida "created" para inicialização do componente
    async created() {        
        await this.initializeProvincias();
        await this.initializeMunicipios();
        this.setFields();
    },

    methods: {
        // Método para inicializar as províncias
        async initializeProvincias() {
            try {
                this.overlay = true; // Ativa sobreposição de progresso
                this.provinciasAll = await axios.get('/provinciaFindAll').then(res => res.data);
            } catch (error) {
                this.text = error;
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
            } finally {
                this.overlay = false; // Desativa sobreposição de progresso
            }
        },

        // Método para inicializar os municípios
        async initializeMunicipios() {
            try {
                this.overlay = true; // Ativa sobreposição de progresso
                this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data);
            } catch (error) {
                this.text = error;
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
            } finally {
                this.overlay = false; // Desativa sobreposição de progresso
            }
        },

        // Método para definir os campos do formulário com os dados do estudante
        async setFields() {
            this.estudanteInfo = this.estudante;
            // Filtrando a provincia com base no idProvincia(provincia) actual do estudante
            this.provinciaSelected = this.provinciasAll.filter((p) => p.idProvincia === this.estudanteInfo.provincia)[0];
            // Filtrando o município com base no idMunicipio(municipio) actual do estudante
            this.municipioSelected = this.municipiosAll.filter((m) => m.idMunicipio === this.estudanteInfo.municipio)[0];
            // Filtrando o sexo com base no idSexo(sexo) actual do estudante
            this.sexoSelected = this.dropdowSexo.filter((s) => s.idSexo === this.estudanteInfo.sexo)[0];
            // Filtrando o periodo com base no id(periodo) actual do estudante
            this.periodoSelected = this.periodos.filter((p) => p.id === this.estudanteInfo.periodo)[0];
        },

        // Método para alternar entre BI e outro documento
        outroDoc() {
            if (this.descricao === 'Outro Doc.') {
                // this.estudanteInfo.bi = '';
                this.descricao = 'Nº do BI';
                this.mascara = '#########-AA-###';
                this.ruleBI = [value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'];
                this.editarDados = false;
            } else {
                // this.estudanteInfo.bi = '';
                this.descricao = 'Outro Doc.';
                this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
                this.ruleBI = [value => value.length >= 6 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'];
                this.editarDados = true;
            }
        },

        // Método para salvar a data de emissão do documento
        salvarDataDocumento(data) {
            this.$refs.menubi.save(data)
            this.estudanteInfo.dataemissaobi = data
            this.dataEmissaoDocumento = new Date(data).toISOString().substr(0, 10)
        },

        // Método para salvar a data de nascimento
        salvarDataNascimento(data) {
            this.$refs.menu.save(data)
            this.estudanteInfo.data_nascimento = data
            this.dataNascimento = new Date(data).toISOString().substr(0, 10)
        },

        // Método para carregar municípios com base na província selecionada
        loadMunicipioComb(provincia) {
            // Verificando se o município atual pertence a provícia atual
            // Se sim, então não precisa "limpar" o município
            if (provincia.idProvincia !== this.municipioSelected.idProvincia) this.municipioSelected = null;
            this.municipiosFiltered = this.municipiosAll.filter((municipio) => municipio.idProvincia === provincia.idProvincia);
        },

        // Método para guardar os dados do estudante
        Guardar() {
            if (this.$refs.form.validate()) {
                Swal.fire({
                    title: 'Editar dados do estudante',
                    text: "Atualizar dados do estudante?",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Continuar',
                    reverseButtons: true,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.overlay = true;
                        try {
                            let params = {
                                nome: this.estudanteInfo.nome ? this.estudanteInfo.nome.trim() : '',
                                bi: this.estudanteInfo.bi,
                                dataEmissaoBi: this.estudanteInfo.dataemissaobi,
                                pai: this.estudanteInfo.pai ?  this.estudanteInfo.pai.trim() : '',
                                mae: this.estudanteInfo.mae ? this.estudanteInfo.mae.trim() : '',
                                dataNascimento: this.estudanteInfo.data_nascimento,
                                provinciaId: this.provinciaSelected.idProvincia,
                                municipioId: this.municipioSelected.idMunicipio,
                                sexo: this.sexoSelected.idSexo,
                                periodo: this.periodoSelected.id,
                                telefone: this.estudanteInfo.telefone ? this.estudanteInfo.telefone.trim() : '',
                                email: this.estudanteInfo.email ? this.estudanteInfo.email.trim() : '',
                                matricula: this.estudanteInfo.numero_matricula,
                                idCliente: this.estudanteInfo.idCliente
                            }

                            let result = await axios.post('estudanteEditarInformacoes', params).then((res => res.data))

                            // Verifica se a operação foi bem sucedida
                            if (result.affectedRows >= 1) {
                                Swal.fire('Informação', '<p>Atualização feita com sucesso.</p>', 'success')
                                this.$emit('fecharComponente', false);
                            } else if (result.messages == 'Duplicate') {
                                Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
                            } else {
                                utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação!')
                            }
                        } catch (error) {                            
                            utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação!')
                        } finally {
                            this.overlay = false;
                        }
                    }
                })
            }
        },

        FecharCard() {
            // Limpa os campos e seleciona para fechar o componente
            this.estudanteInfo = null;
            this.municipioSelected = null;
            this.provinciaSelected = null;
            this.provinciasAll = [];
            this.municipiosAll = [];
            this.municipiosFiltered = [];
            this.sexoSelected = null;
            this.$emit('fecharComponente', false);
        }
    }
}
</script>

<style scoped></style>
